import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Footer from "../../../components/Footer/Footer";
import './contract.less';
import { useScrollHeader } from '../../../hooks';

export default function Contract({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false)

  const newsData = [
    {
      title: '集视医疗弱视方案临床试验初步访视结果出炉，001号患者4周基本治愈！',
      date: '2024-10-11',
      desc: '苏州集视医疗科技有限公司（以下简称“集视医疗”）于国内由复旦大学附属眼耳鼻喉科医院牵头，联合多中心开展的全球首个“基于AR技术的全年龄段弱视治疗方案的有效性和安全性”的前瞻性…',
      img: '/images/news/news2.png',
      route: '/newsInfo/amblyopiaClinical'
    },
    {
      title: '集视医疗亮相中华医学会第二十八次眼科学术大会',
      date: '2024-09-04',
      desc: '2024年9月4-8日，中华医学会第二十八次眼科学术大会在武汉国际博览中心隆重举行，作为年度眼科行业最盛大的学术会议，全球逾万名专家、学者相聚于此，交流分享眼科和视觉科学方面最新研究成果…',
      img: '/images/news/news3.png',
      route: '/newsInfo/academic'
    },
    {
      title: '集视医疗完成Pre-A轮融资',
      date: '2024-08',
      desc: '据悉，集视医疗已于近期完成由复健资本独家投资的Pre-A轮融资。随着本轮资金的成功注入，集视医疗将大幅提升产能，不断巩固和拓展其全年龄段弱视治疗方案，扎实推进已获批产品的商业化进程…',
      img: '/images/news/news4.png',
      route: '/newsInfo/pre'
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div>
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>公司动态 / 最新资讯 / 温州医科大学附属眼视光医院＆集视医疗战略合作签约</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/companyNews', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className="article_title">
              <div className='article_titleTop c_85899E'>
                公司动态 / 公司资讯
                <span className='ml_54'>2024.10.31</span>
              </div>
              <div className="article_titleBottom">温州医科大学附属眼视光医院＆集视医疗战略合作签约</div>
            </div>
            <div className="article_content">
              <div className="article_content-text">
                2024年10月，集视医疗与温州医科大学附属眼视光医院达成了一项具有里程碑意义的战略合作协议。根据协议，集视医疗的视功能训练产品将正式入驻温州医科大学附属眼视光医院的视功能训练室， 由视光诊疗中心双眼视训练室负责人郑医生牵头，为患者带来更全面、更科学的视功能训练服务。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/contractImg.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                集视医疗是由全球领先的脑科学、眼科临床、可穿戴技术深度融合的产学研团队组成，结合脑科学深入研究眼科相关疾病的发病机制并设计针对性诊疗范式， 开发基于可穿戴设备、符合临床路径、个性化、高依从性的诊疗产品。从成人弱视切入，未来拓展到低视力、青光眼、干眼等全方位眼健康数字化管理，全面提升眼科治疗的整体水平， 改善患者的生活质量，弥补当前眼科治疗的短板。
              </div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/arvo'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/amblyopiaClinical'))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/arvo'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/amblyopiaClinical'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="PreA_right">
        <div className='PreA_marginMobile'>
          <div className='PreA_right-searchBlock flex_row flex_ai-c'>
            <div className='of_hidden' style={{ width: '100%' }}>
              <input
                className="PreA_input flex_full"
                style={{ width: '100%' }}
                type="text"
                // value={demand}
                // onChange={(e) => setDemand(e.target.value)}
                placeholder="搜索文章"
              />
              <div className='PreA_input-line'></div>
            </div>
            <img
              className='PreA_right-icon flex_auto'
              src='/images/news/right.png'
              alt=''
            />
          </div>
          <div className="article_rightType">
            <div className='fz_18 fw_500 lh_21'>文章分类</div>
            <div className='article_rightType-block'>
              <div className='PreA_right-item flex_center'>公司资讯</div>
              <div className='PreA_right-item flex_center'>最新资讯</div>
            </div>
          </div>
          <div className='article_rightMore'>
            <div className='fz_18 fw_500 lh_21'>更多资讯</div>
            <div className='mt_16'>
              <div className='of_hidden'>
                <div className='article_rightMoreBlock flex_col'>
                  {newsData.map((item, index) => <div
                    key={index}
                    className='article_rightItem cur_p'
                    onClick={(() => navigate(item.route))}
                  >
                    <div className='article_rightItemBlock'>
                      <div className='PreA_right-itemImg flex_center'>
                        <img
                          style={{ width: '100%' }}
                          src={item.img}
                          alt=''
                        />
                      </div>
                      <div className='article_rightItem-date c_85899E flex_row flex_jc-sb'>
                        <div>{item.date}</div>
                        <div className='article_rightItem-type'>最新资讯</div>
                      </div>
                      <div className='article_rightItem-title of_ellipsis'>{item.title}</div>
                      <div className='article_rightItem-desc multiline-ellipsis-2'>{item.desc}</div>
                    </div>
                  </div>)}
                </div>
              </div>
            </div>
            <div className='PreA_right-btnBlock'>
              <div
                className='PreA_right-btn flex_row flex_jc-c flex_ai-c'
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={(() => navigate('/companyNews'))}
              >
                全部资讯
                <img
                  class="PreA_right-arrow"
                  alt=""
                  src={hovered ? '/images/home/arrow-right-whiteLine.png' : '/images/home/arrow-right-blackLine.png'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
}
